import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export function Users() {
  const { setModal } = useContext(ModalContext);
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  const format = new DateUtils();

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get('/api/user/search', {
        params: {
          page: page,
          search: search
        }
      })
      .then(async (res) => {
        setPayload(res.data.data);

        var data = [];
        for (const value of res.data.data.data) {
          const [first_name, ...last_nameParts] = value.name.split(' ');
          const last_name = last_nameParts.join(' ');
          const permission =
            value.permission ||
            value.account?.find((acc) => acc.id === value.default_account)
              ?.permission ||
            value.account?.[0]?.permission ||
            'user';

          const timezone = await format.getTimezone();

          data.push({
            id: value.id,
            name: value.name,
            first_name,
            last_name,
            email: value.email,
            permission,
            agency_id: value.agency?.id || value.default_account,
            agency: value.agency ? (
              <a
                href={
                  window.location.host === 'localhost:5002'
                    ? `http://localhost:5002/admin/agency/${value.agency.id}`
                    : `https://admin.coverbadger.com/admin/agency/${value.agency.id}`
                }
                target="_blank"
                rel="noreferrer"
                style={{ color: 'blue', textDecoration: 'underline' }}
              >
                {value.agency.name}
              </a>
            ) : (
              'Not Found'
            ),
            createdAt: format.timestamp(value.date_created, timezone),
            status: value.disabled ? 'Inactive' : 'Active',
          });
        }


        setLoading(false);
        setData(data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <IconedButton
            size="140px"
            color="#d32425"
            textColor="white"
            icon="plus-circle"
            text="Add User"
            marginRight
            action={() => {
              setModal({
                name: 'user_modal',
              });
            }}
          />
        </div>
      </div>
      {window.location.host === 'localhost:5002' ? (
        <iframe
          id="receiver"
          src={`http://localhost:3000`}
          width="500"
          height="200"
          style={{ display: 'none' }}
        />
      ) : (
        <iframe
          id="receiver"
          src={`https://app.coverbadger.com`}
          width="500"
          height="200"
          style={{ display: 'none' }}
        />
      )}
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ marginBottom: 10 }}>
            <Search
              callback={(query) => {
                setSearchQueryString(query);
              }}
            />
          </div>
          <Table
            data={data}
            hide={[
              'id',
              'first_name',
              'last_name',
              'permission',
              'agency_id',
            ]}
            loading={loading}
            badge={{
              col: 'status',
              condition: [
                { value: 'Active', color: 'green' },
                { value: 'Inactive', color: 'red' },
              ],
            }}
            actions={{
              custom: (row) => {
                const actions = [
                  {
                    icon: 'edit',
                    action: () => {
                      setModal({
                        name: 'user_modal',
                        mode: 'edit_mode',
                        data: row,
                        action: () => {
                          runAPI(page, searchQueryString);
                        },
                      });
                    },
                    color: '#637381',
                    tooltip: 'Edit',
                  },
                ];

                if (row.status === 'Active') {
                  actions.push({
                    icon: 'log-out',
                    action: () => {
                      setModal({
                        name: 'confirmation',
                        data: {
                          title: `Impersonate user`,
                          description: `Do you want to impersonate this user?`,
                        },
                        action: async () => {
                          setModal({});
                          try {
                            const res = await axios.post('/api/impersonate', {
                              impersonatableId: row.id,
                              type: 'user',
                            });

                            const receiver = document.getElementById('receiver').contentWindow;
                            receiver.postMessage(
                              res.data,
                              window.location.host === 'localhost:5002'
                                ? 'http://localhost:3000'
                                : 'https://app.coverbadger.com'
                            );

                            window.open(
                              window.location.host === 'localhost:5002'
                                ? 'http://localhost:3000/app/dashboard'
                                : 'https://app.coverbadger.com/app/dashboard'
                            );
                          } catch (err) {
                            console.log(err);
                            setModal('');
                          }
                        },
                      });
                    },
                    color: '#637381',
                    tooltip: 'Impersonate',
                  });
                }

                return actions;
              },
            }}
          />
          {payload && !loading && (
            <Pagination
              pagesCount={payload.pages_count}
              active={payload.page}
              onChange={async (newPage) => {
                setPage(newPage);
                runAPI(newPage, searchQueryString);
              }}
            />
          )}
        </div>
      </Grid>
    </Animate>
  );
}
